import React from 'react';
import { ContentPanel } from '../../ContentPanel';
import { SidebarPanelTitle } from '../SidebarPanelTitle';
import { Box, CustomTheme, useTheme } from '@mui/material';
import { ISidebarPanel } from './interface';

export const SidebarPanel: React.FC<ISidebarPanel> = ({
  title,
  children,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  return (
    <ContentPanel borderRadius="none">
      {title && (
        <SidebarPanelTitle
          title={title}
          sx={{
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
            mb: '15px',
          }}
        />
      )}
      <Box>{children}</Box>
    </ContentPanel>
  );
};
